import type {
  WCmsPageView,
  WCmsHomepageSectionView,
  WCmsVideoView,
  WCmsFaqView,
  WCmsPhotoView,
  WCmsWeddingRegistryView,
  WCmsEventView,
  WCmsPoiView,
  WCmsTravelView,
  WCmsWeddingPartyMemberView,
} from '@zola/svc-web-api-ts-client';

import type { EntitiesStateType } from './context';

export type ENTITIES =
  | WCmsHomepageSectionView[]
  | WCmsVideoView[]
  | WCmsVideoView
  | WCmsFaqView[]
  | WCmsPhotoView[]
  | WCmsWeddingRegistryView[]
  | WCmsEventView[]
  | WCmsPoiView[]
  | WCmsTravelView[]
  | WCmsWeddingPartyMemberView[];

export enum ActionTypes {
  RECEIVE_ENTITIES = 'RECEIVE_ENTITIES',
  RECEIVE_PAGES = 'RECEIVE_PAGES',
  SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE',
  RECEIVE_PAGE = 'RECEIVE_PAGE',
}

type RECEIVE_PAGES_ACTION = {
  type: typeof ActionTypes.RECEIVE_PAGES;
  payload: {
    pages: WCmsPageView[];
  };
};

type RECEIVE_PAGE_ACTION = {
  type: typeof ActionTypes.RECEIVE_PAGE;
  payload: {
    page: WCmsPageView;
  };
};

type SET_ACTIVE_PAGE_ACTION = {
  type: typeof ActionTypes.SET_ACTIVE_PAGE;
  payload: {
    activePageType: string | undefined;
  };
};

export type PagesActions = RECEIVE_PAGES_ACTION | RECEIVE_PAGE_ACTION | SET_ACTIVE_PAGE_ACTION;

export enum EntitiesPropertyNames {
  homepage_sections = 'homepage_sections',
  homepage_video = 'homepage_video',
  faqs = 'faqs',
  photos = 'photos',
  videos = 'videos',
  wedding_registries = 'wedding_registries',
  events = 'events',
  pois = 'pois',
  travel = 'travel',
  wedding_party_members = 'wedding_party_members',
}

type RECEIVE_ENTITIES_ACTION = {
  type: typeof ActionTypes.RECEIVE_ENTITIES;
  payload: {
    entities: EntitiesStateType;
  };
};

export type EntitiesActions = RECEIVE_ENTITIES_ACTION;
